import { render, staticRenderFns } from "./withhold.vue?vue&type=template&id=d6b7f51a&scoped=true"
import script from "./withhold.vue?vue&type=script&lang=ts"
export * from "./withhold.vue?vue&type=script&lang=ts"
import style0 from "./withhold.vue?vue&type=style&index=0&id=d6b7f51a&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b7f51a",
  null
  
)

export default component.exports